// client/src/pages/RegisterPage.js
import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Container, Card, Typography, TextField, Button, Alert, Stack, Box } from '@mui/material';
import { API_BASE_URL } from '../utils/media';
import { useStore } from '../context/StoreContext';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');
  const { store } = useStore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth/register`, { email, password });
      navigate(`/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '75vh', display: 'grid', placeItems: 'center', py: 8, px: 2,
        background:
          'radial-gradient(700px 400px at 100% 0%, rgba(53,99,233,0.14), transparent 60%),' +
          'radial-gradient(600px 400px at 0% 100%, rgba(255,140,80,0.14), transparent 60%)',
      }}
    >
      <Container maxWidth="xs" disableGutters>
        <Typography variant="overline" color="primary" sx={{ fontWeight: 800, letterSpacing: '0.14em' }}>
          Join us
        </Typography>
        <Typography variant="h3" fontWeight={800} letterSpacing="-0.02em" sx={{ fontSize: '2.2rem', mb: 3 }}>
          Create your {store.name} account
        </Typography>
        <Card sx={{ p: { xs: 3, sm: 4 }, borderRadius: 5 }}>
          <Stack component="form" onSubmit={handleSubmit} spacing={2.25}>
            {error && <Alert severity="error" sx={{ borderRadius: 3 }}>{error}</Alert>}
            <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required fullWidth autoComplete="email" />
            <TextField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required fullWidth autoComplete="new-password" />
            <Button type="submit" variant="contained" size="large" disabled={loading} sx={{ py: 1.5, fontWeight: 700 }}>
              {loading ? 'Creating account…' : 'Create account'}
            </Button>
          </Stack>
        </Card>
        <Typography variant="body2" textAlign="center" sx={{ mt: 3, color: 'text.secondary' }}>
          Already have an account?{' '}
          <Link to={`/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`} style={{ color: 'inherit', fontWeight: 700 }}>
            Sign in
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default RegisterPage;
